import { MACHINES } from "@/data/machines";
import { Corners, PageHead, Reveal, StatusDot, Tag } from "@/components/ui-kit";

const MachineCard = ({ m }) => {
  const onMove = (e) => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const r = e.currentTarget.getBoundingClientRect();
    const rx = ((e.clientY - r.top) / r.height - 0.5) * -5;
    const ry = ((e.clientX - r.left) / r.width - 0.5) * 5;
    e.currentTarget.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`;
  };
  const onLeave = (e) => { e.currentTarget.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg)"; };
  return (
    <div
      data-testid={`machine-card-${m.id.toLowerCase()}`}
      data-cursor="SCAN"
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className="hud-panel relative p-5 group transition-transform duration-200 will-change-transform overflow-hidden"
    >
      <Corners />
      <div className="absolute inset-x-0 h-px bg-gradient-to-r from-transparent via-arc-cyan/60 to-transparent opacity-0 group-hover:opacity-100 anim-sweep pointer-events-none" aria-hidden="true" />
      <div className="flex items-center justify-between mb-1">
        <span className="font-mono text-base text-arc-white tracking-wider">{m.id}</span>
        <span className="flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] text-arc-silver/60"><StatusDot status={m.status} />{m.status}</span>
      </div>
      <div className="font-mono text-[10px] tracking-[0.3em] text-arc-electric mb-4">{m.type}</div>
      <div className="border border-dashed border-arc-blue/20 p-3 mb-4 space-y-1.5 font-mono text-[11px]">
        <div className="flex justify-between"><span className="text-arc-silver/40">LOC</span><span className="text-arc-silver/80">{m.location}</span></div>
        <div className="flex justify-between"><span className="text-arc-silver/40">TASK</span><span className="text-arc-cyan">{m.task}</span></div>
        <div className="flex justify-between"><span className="text-arc-silver/40">REP</span><span className="text-arc-green">{m.reputation}</span></div>
        <div className="flex justify-between"><span className="text-arc-silver/40">BAL</span><span className="text-arc-silver/80">{m.balance}</span></div>
      </div>
      <div className="flex flex-wrap gap-1.5">{m.capabilities.map((c) => <Tag key={c}>{c}</Tag>)}</div>
      <div className="mt-4 flex justify-between font-mono text-[8px] tracking-[0.25em] text-arc-silver/25">
        <span>BP.{m.id}</span><span>SCALE 1:1</span><span>REV 04</span>
      </div>
    </div>
  );
};

const MachinesPage = () => (
  <div data-testid="machines-page" className="pb-24">
    <PageHead
      eyebrow="MODULE 03 // HARDWARE"
      title="MACHINE REGISTRY"
      subtitle="Physical intelligence connected to autonomous coordination. Rovers, drones, humanoids, robotic arms, industrial systems and autonomous vehicles."
      note="SIMULATED REGISTRY — DEMO ENTRIES ONLY"
    />
    <div className="px-5 sm:px-8 max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {MACHINES.map((m, i) => (
        <Reveal key={m.id} delay={i * 0.05}><MachineCard m={m} /></Reveal>
      ))}
    </div>
  </div>
);

export default MachinesPage;
